import { useState, useMemo } from "react";
import { calculateTotal } from "../utils/calculateTotal.js"; // adapte ton import
import { logDev } from "../utils/logger.js"

export function usePeriodeDominante(contacts, safePeriodes) {
  const [periodePrivilegiee, setPeriodePrivilegiee] = useState(null);

  const { dominantKeys, periodeDominanteEffective, totals } = useMemo(() => {
    // sécurité : si pas de périodes, retourne vide
    if (!Array.isArray(safePeriodes) || safePeriodes.length === 0) {
      return { dominantKeys: [], periodeDominanteEffective: null, totals: [] };
    }
    
    // Totaux par période (avec vrais _id)
    const totals = safePeriodes.map((periode) =>
      /*calculateTotal(contacts, `periode${i + 1}`)*/
      calculateTotal(contacts, periode._id)
    );

    const maxTotal = Math.max(...totals);

    // Clés dominantes = les _id des périodes ayant le max
    const dominantKeys = safePeriodes
      .map((periode, i) => (totals[i] === maxTotal ? periode._id : null))
      .filter(Boolean);

    let periodeDominanteEffective = null;

    if (dominantKeys.length === 1) {
      
      // Une seule dominante → on la prend
      periodeDominanteEffective = dominantKeys[0];
    } else if (dominantKeys.length > 1 && periodePrivilegiee) {
      
      // Plusieurs ex æquo → si l’admin a choisi, on respecte son choix
      periodeDominanteEffective = periodePrivilegiee;
    }

    return { dominantKeys, periodeDominanteEffective, totals };
  }, [contacts, safePeriodes, periodePrivilegiee]);

  // 🔹 Un seul log global
  logDev("[usePeriodeDominante] résultat", {
    totals,
    dominantKeys,
    periodeDominanteEffective,
    periodePrivilegiee
  });

  return { 
    dominantKeys, 
    periodeDominanteEffective, 
    periodePrivilegiee, 
    setPeriodePrivilegiee, 
    totals 
  };
}
